import { Flex, Typography } from 'antd'
import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { useStyle } from './styles'

export const AuthWrapper = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation()
  const { styles } = useStyle()

  return (
    <Flex
      justify="space-between"
      align="center"
      vertical
      className={styles.containerBackground}
    >
      <Flex className={styles.flexQuestions} justify="end" gap={8}>
        <Typography.Text>{t('common.have_questions')}</Typography.Text>
        <Link to="https://ebs-integrator.com" target="_blank">
          {t('common.contact_us')}
        </Link>
      </Flex>

      <div className={styles.childrenContainer}>{children}</div>

      <Flex className={styles.footer} gap={8}>
        <Typography.Paragraph>{t('common.designed_by')}</Typography.Paragraph>
        <Link to="https://ebs-integrator.com" target="_blank">
          EBSIntegrator
        </Link>
      </Flex>
    </Flex>
  )
}
